
// changes
export default function MapLegend(props) {
  return (
    <svg viewBox="40 0 250 25" height="25" width="380" align="center" {...props}>
      <text
        x="5"
        y="12"
        style={{
          width: '57px',
          height: '16px',
          fontWeight: 400,
          fontSize: '12.64px',
        }}
      >
        Very High
      </text>
      <rect
        x="95"
        y="0"
        width="16"
        height="16"
        fill="#C40000"
        stroke="#C40000"
        strokeWidth="1px"
      ></rect>
      <rect
        x="114"
        y="0"
        width="16"
        height="16"
        fill="#DF5A42"
        stroke="#DF5A42"
        strokeWidth="1px"
      ></rect>
     
<rect
           x="132"
        y="0"
        width="16"
        height="16"
        fill="#F3927E"
        stroke="#FF1A1A"
        strokeWidth="1px"
      ></rect>
<rect
        x="150"
        y="0"
        width="16"
        height="16"
       fill="#FEC8B9"
        stroke="#FF1A1A"
        strokeWidth="1px"
      ></rect>
      
      <rect
        x="168"
        y="0"
        width="16"
        height="16"
        fill="#FFFFF0"
        stroke="#AD8D01"
        strokeWidth="1px"
      ></rect>

<rect
        x="186"
        y="0"
        width="16"
        height="16"
         fill="#C6E8DF"
        stroke="#15A796"
        strokeWidth="1px"
      ></rect>
      
       <rect
        x="204"
        y="0"
        width="16"
        height="16"
        fill="#6CB2A2"
        stroke="#6CB2A2"
        strokeWidth="1px"
      ></rect>
       
       <rect
        x="222"
        y="0"
        width="16"
        height="16"
        fill="#218371"
        stroke="#218371"
        strokeWidth="1px"
      ></rect>
      <text
        x="276"
        y="12"
        style={{
          width: '57px',
          height: '16px',
          fontWeight: 400,
          fontSize: '12.64px',
        }}
      >
        Minimal
      </text>
      
    </svg>
  )
}
